import { FixaSkeleton } from "../../../shared/wrappers/FixaSkeleton/FixaSkeleton";

const SkeletonTableCell = () => (
  <td>
    <FixaSkeleton width="100px" height="21px" />
  </td>
);

const SkeletonTableRow = () => (
  <tr>
    <SkeletonTableCell />
    <SkeletonTableCell />
    <SkeletonTableCell />
    <SkeletonTableCell />
  </tr>
);

const SkeletonTableRows = () => (
  <>
    {[...Array(5)].map((_, index) => (
      <SkeletonTableRow key={index} />
    ))}
  </>
);

export default SkeletonTableRows;
